import HeaderType from '../../store/schema/HeaderType';
import strings from 'owa-strings/owa-options-strings';

export default function getHeaderTextFromHeaderType(headerType: HeaderType): string {
    switch (headerType) {
        case 'organize':
            return strings.options_inboxRules_organize;
        case 'markMessage':
            return strings.options_inboxRules_markMessage;
        case 'route':
            return strings.options_inboxRules_route;
        case 'addresses':
            return strings.options_inboxRules_people;
        case 'myNameIs':
            return strings.options_inboxRules_myNameIs;
        case 'subject':
            return strings.options_inboxRules_subject;
        case 'includesTheseWords':
            return strings.options_inboxRules_includesWords;
        case 'markedWith':
            return strings.options_inboxRules_markedWith;
        case 'messageIncludes':
            return strings.options_inboxRules_messageIncludes;
        case 'messageSize':
            return strings.options_inboxRules_messageSize;
        case 'received':
            return strings.options_inboxRules_received;
        case 'allMessages':
            return strings.options_inboxRules_allMessages;
        default:
            throw new Error('Cannot get header text for a header type that does not exist');
    }
}
